import { useQuery } from "react-query";
import { getAssignableCliniciansAsync } from "api/clinicians";
import { ASSIGNABLE_CLINICIANS } from "@constants/reactQueryKeys";

export const useGetAssignableClinicians = () => {
  const { data, isLoading, ...rest } = useQuery([ASSIGNABLE_CLINICIANS], () =>
    getAssignableCliniciansAsync()
  );

  return {
    assignableClinicians: data?.data || null,
    assignableCliniciansLoading: isLoading,
    ...rest,
  };
};
